export default __webpack_public_path__ + "static/media/barrier.52073a48.jpg";